/**
 * ユーザの所属する組織名の取得
 * @param user
 * @returns {string}
 */
export const userOrganizationName = (user) => (user && user.organization && user.organization.name) || '';
export default userOrganizationName;
